<template>
    <div>
        <form @submit.prevent="scanWm">
            <p class="font-semibold py-2">Barcode:</p>
            <input
                class="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="scanWm"
                type="text"
                ref="wm"
                placeholder="WM"
                v-model="wm"
            />
            <!-- <input
                v-if="!notGrabowski"
                v-model="barcode2"
                ref="bar2"
                class="shadow mx-2 appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="barcode2"
                type="text"
                placeholder="Barcode"
                /> -->
            <button type="submit"  hidden
                class="uppercase ml-4 focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
            >
                Scan
            </button>
            <div class="py-4">

            <span v-if="msg" class="font-semibold text-lg text-green-600">
                {{ msg }}
            </span>
            <!-- <span v-else class="font-semibold text-lg text-red-700">Overflow</span> -->
            <!-- <span v-if="notFound" class="font-semibold text-lg text-red-700">
                {{ notFound }}
            </span> -->
            </div>
        </form>
        <div class="py-2 text-right">
            <router-link
                to="/scan-aw"
                class="bg-teal-400 text-white px-4 py-1 uppercase rounded shadow-lg hover:bg-teal-300">
                Back
            </router-link>
        </div>
    <div
      class="align-middle inline-block min-w-full overflow-hidden border border-gray-400">
      <table class="min-w-full">
        <thead>
          <tr>
            <th
              class="px-2 py-2 border border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
            >
              Nr
            </th>
            <th
              class="px-2 py-2 border border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
            >
              Numer
            </th>
            <th
              class="px-2 py-2 border border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
            >
              WM
            </th>
            <th
              class="px-2 py-2 border border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
            >
              Closed
            </th>
          </tr>
        </thead>
        <tbody  v-for="(wm, index) in wms" :key="index.id" class="bg-white">
          <tr>
            <td
              class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
            >
              {{ ++index }}
            </td>
            <td
              class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
            >
              {{ wm.tr_numer }}/HC/20/WM
            </td>
            <td
              class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
            >
              {{ wm.wm_idtrans }}
            </td>
            <td
              class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
            >
              <span v-if="wm.scanned == 1" class="text-green-500"
                ><svg
                  class="scan-status"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  /></svg>
              </span>
              <span v-else-if="wm.scanned == 2">
                <svg
                  version="1.1"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 451.74 451.74"
                  style="enable-background: new 0 0 451.74 451.74"
                  xml:space="preserve"
                  class="scan-status"
                >
                  <path
                    style="fill: #e24c4b"
                    d="M446.324,367.381L262.857,41.692c-15.644-28.444-58.311-28.444-73.956,0L5.435,367.381
    c-15.644,28.444,4.267,64,36.978,64h365.511C442.057,429.959,461.968,395.825,446.324,367.381z"
                  />
                  <path
                    style="fill: #ffffff"
                    d="M225.879,63.025l183.467,325.689H42.413L225.879,63.025L225.879,63.025z"
                  />
                  <g>
                    <path
                      style="fill: #3f4448"
                      d="M196.013,212.359l11.378,75.378c1.422,8.533,8.533,15.644,18.489,15.644l0,0
        c8.533,0,17.067-7.111,18.489-15.644l11.378-75.378c2.844-18.489-11.378-34.133-29.867-34.133l0,0
        C207.39,178.225,194.59,193.87,196.013,212.359z"
                    />
                    <circle
                      style="fill: #3f4448"
                      cx="225.879"
                      cy="336.092"
                      r="17.067"
                    />
                  </g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                </svg>
              </span>
              <span v-else class="text-red-500">
                  <svg
                  class="scan-status"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                    clip-rule="evenodd"
                  /></svg
              ></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            wm: '',
            msg: '',
            error: '',
            wms: [],
            id: JSON.parse(localStorage.getItem('aw-number')),
            aw: JSON.parse(localStorage.getItem('aw'))
        }
    },
    created() {
        this.getWms();

        this.$nextTick(function () {
            this.$refs.wm.focus();
        });
        // console.log(this.aw)
        // console.log(this.id)
    },
    methods: {
       getWms() {
            // console.log(this.aw)
            // console.log(this.id)
            
            axios.defaults.headers.common["Authorization"] =
            "Bearer " + localStorage.getItem("access_token");

            axios.get(`${process.env.VUE_APP_API}/wms`, {
                params: {
                    id: this.id,
                    aw: this.aw,
                }
            })
            .then(response => {
                this.wms = response.data;
                console.log(this.wms);
            })
            .catch(error => {
                // console.log(error)
                this.error = error.response.data;
            })
       },
       scanWm() {
            axios.post(`${process.env.VUE_APP_API}/scan-wms`, {
                aw_idtrans: this.id,
                wm_idtrans: this.wm
            })
            .then((response) => {
                console.log(response.data)

                this.wm = ""
                this.getWms();
                this.msg = response.data;

            }).finally(() => {
                this.wm = "";
                this.$nextTick(function () {
                    this.$refs.wm.focus();
                });
            })
       }
    }
}
</script>

<style scoped>
.scan-status {
  width: 30px;
  margin: auto;
}
</style>